// Source INSEE : https://www.insee.fr/fr/statistiques/fichier/2120875/naf2008_liste_n5.xls
import labels from './nafLabels.json';
export function activityFromApe(code) {
  const normalized = String(code || '').toUpperCase().replace(/[.\s]/g, '');
  return labels[normalized.replace(/^(\d{2})(\d{2}[A-Z])$/, '$1.$2')] || '';
}
export function companyActivity(client) {
  return activityFromApe(client?.APE || client?.ape) || client?.activity || '';
}
